import { Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import PanelDeControl from '../../components/ajustes/PanelDeControl';
import AsignarDirector from '../../components/ajustes/AsignarDirector';
import GestionUsuariosAutorizados from '../../components/ajustes/GestionUsuariosAutorizados';
import GestionUsuariosMcp from '../../components/ajustes/GestionUsuariosMcp';

const Actas = () => {
  return (
    <>
      <Col md="12">
        <ComponentCard title="Administrar aplicación" hasButton={false}>
          <PanelDeControl />
        </ComponentCard>
        <ComponentCard title="Director de centro" hasButton={false}>
          <AsignarDirector />
        </ComponentCard>
        <ComponentCard title="Usuarios autorizados" hasButton={false}>
          <GestionUsuariosAutorizados />
        </ComponentCard>
        <ComponentCard title="Usuarios del MCP de alumnos" hasButton={false}>
          <GestionUsuariosMcp />
        </ComponentCard>
      </Col>
    </>
  );
};
export default Actas;
